module.exports = __webpack_public_path__ + "img/logo.513742b6.svg";